
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PGlvLmt0b3I6a3Rvci1jbGllbnQtY29yZT4 from './ktor-ktor-client-core.mjs';
import * as PGlvLmt0b3I6a3Rvci1odHRwPg from './ktor-ktor-http.mjs';
import * as PGlvLmt0b3I6a3Rvci1pbz4 from './ktor-ktor-io.mjs';
import * as PGlvLmt0b3I6a3Rvci1zZXJpYWxpemF0aW9uPg from './ktor-ktor-serialization.mjs';
import * as PGlvLmt0b3I6a3Rvci11dGlscz4 from './ktor-ktor-utils.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci1jbGllbnQtY29yZT4__ALL_EXPORTS } from './ktor-ktor-client-core.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci1odHRwPg__ALL_EXPORTS } from './ktor-ktor-http.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci1pbz4__ALL_EXPORTS } from './ktor-ktor-io.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci1zZXJpYWxpemF0aW9uPg__ALL_EXPORTS } from './ktor-ktor-serialization.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci11dGlscz4__ALL_EXPORTS } from './ktor-ktor-utils.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<io.ktor:ktor-utils>': PGlvLmt0b3I6a3Rvci11dGlscz4__ALL_EXPORTS,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<io.ktor:ktor-io>': PGlvLmt0b3I6a3Rvci1pbz4__ALL_EXPORTS,
    '<io.ktor:ktor-http>': PGlvLmt0b3I6a3Rvci1odHRwPg__ALL_EXPORTS,
    '<io.ktor:ktor-client-core>': PGlvLmt0b3I6a3Rvci1jbGllbnQtY29yZT4__ALL_EXPORTS,
    '<io.ktor:ktor-serialization>': PGlvLmt0b3I6a3Rvci1zZXJpYWxpemF0aW9uPg__ALL_EXPORTS,
};
    